import React from 'react'
import { useState,useEffect } from 'react';
import { Container,Row,Col } from "react-bootstrap";
import { ArrowRightCircle } from 'react-bootstrap-icons';
import headerImg from "../assets/img/DSC_0056.png";


import { useCallback } from "react";
import Particles from "react-particles";
//import { loadFull } from "tsparticles"; 
import { loadSlim } from "tsparticles-slim"; 





export const  Banner = () => {
    const[loopNum,setLoopNum,prevLoopNum]=useState(0);
    const[isDeleting,setIsDeleting]=useState(false);
    const toRotate=["Web Developer","Mobile App Developer"];
    const[text,setText]=useState('');
    const[delta,setDelta]=useState(300-Math.random()*100);
    const period =1000;
    const [index, setIndex] = useState(1);

    useEffect(() => {
        let ticker = setInterval(() => {
          tick();
        }, delta);
    
        return () => { clearInterval(ticker) };
      }, [text])
    
      const tick = () => {
        let i = loopNum % toRotate.length;
        let fullText = toRotate[i];
        let updatedText = isDeleting ? fullText.substring(0, text.length - 1) : fullText.substring(0, text.length + 1);
    
        setText(updatedText);
    
        if (isDeleting) {
          setDelta(prevDelta => prevDelta / 2);
        }
    
        if (!isDeleting && updatedText === fullText) {
          setIsDeleting(true);
          setIndex(prevIndex => prevIndex - 1);
          setDelta(period);
        } else if (isDeleting && updatedText === '') {
          setIsDeleting(false);
          setLoopNum(loopNum + 1);
          setIndex(1);
          setDelta(500);
        } else {
          setIndex(prevIndex => prevIndex + 1);
        }
      }



      useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('view1');
            } else {
              entry.target.classList.remove('view1');
            }
          });
        });
    
        const hiddenElements = document.querySelectorAll('.show1');
        hiddenElements.forEach((el) => observer.observe(el));
    
        return () => {
          hiddenElements.forEach((el) => observer.unobserve(el));
        };
      }, []);



     


    const particlesInit = useCallback(async engine => {
        console.log(engine);
        
        await loadSlim(engine);
    }, []);

    const particlesLoaded = useCallback(async container => {
        await console.log(container);
    }, []);
  

  return (
   <section className="banner" id="home">
    <Particles
            id="tsparticles"
            init={particlesInit}
            loaded={particlesLoaded}
            options={{
                // background: {
                //     color: {
                //         value: "#040D12",
                //     },
                // },
                fpsLimit: 120,
                interactivity: {
                    events: {
                        onClick: {
                            enable: true,
                            mode: "push",
                        },
                        onHover: {
                            enable: true,
                            mode: "repulse",
                        },
                        resize: true,
                    },
                    modes: {
                        push: {
                            quantity: 2,
                        },
                        repulse: {
                            distance: 300,
                            duration: 0.4,
                        },
                    },
                },
                particles: {
                    color: {
                        value: "#4E4FEB",
                    },
                    // links: {
                    //     color: "#ffffff",
                    //     distance: 150,
                    //     enable: true,
                    //     opacity: 0.5,
                    //     width: 1,
                    // },
                    move: {
                        direction: "none",
                        enable: true,
                        outModes: {
                            default: "bounce",
                        },
                        random: false,
                        speed: 1,
                        straight: false,
                    },
                    number: {
                        density: {
                            enable: true,
                            area: 800,
                        },
                        value: 80,
                    },
                    opacity: {
                        value: 0.5,
                    },
                    shape: {
                        type: "circle",
                    },
                    size: {
                        value: { min: 1, max: 5 },
                    },
                },
                detectRetina: true,
            }}
        />
    <Container>
        <Row className="align-items-center">
           <Col xs={12} md={6} xl={7}>
               <div className="text1 show2">
                {/* <span className="tagline">welcome</span> */}
                <h1>{`Hi.. I'm Nimesh `}</h1>
                <h2>Full-Stack Developer</h2>
                <h2><span className="wrap">{text} _</span></h2>
                <p>Hello, I'm Nimesh Kavinda. I am a computer science undergraduate at NSBM Green University. I have basic skills in Full-Stack Development and  Mobile App development. I am a highly motivated, hard working individual trying to develop my skills further to have a successful carreer.</p>
                {/* <p>I am incredibly passionate about the creative and technical aspects of building innovative websites.</p> */}
               
                {/* <button onClick={()=>console.log('connect')}>Let's Connect< ArrowRightCircle size={25}/></button> */}
                </div>
            </Col>
            <Col xs={12} md={6} xl={5}>
                <div className="headerimg">
                <img src={headerImg} alt="Header Img"   />
                </div >
            </Col >
        </Row>
    </Container>

   </section>
  )
}
